import { render, staticRenderFns } from "./BusInspectionBaseConfigModal.vue?vue&type=template&id=6e528d90&"
import script from "./BusInspectionBaseConfigModal.vue?vue&type=script&lang=js&"
export * from "./BusInspectionBaseConfigModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports